import { Injectable } from '@angular/core';
import { TimeDifference } from '../../models';

export interface HoursMinutesAndSeconds {
  hours: number;
  minutes: number;
  seconds: number;
}

@Injectable()
export class TimeConversionProvider {
  convertSecondsToMinutes(seconds: number): number {
    return parseFloat((seconds / 60).toFixed(2));
  }

  /**
   * Returns a TimeDifference object.
   *
   * @param totalMinutes
   */
  convertMinutesToTimeDifference(totalMinutes: number): TimeDifference {
    const totalHours = Math.floor(totalMinutes / 60);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours - days * 24;
    const minutes = totalMinutes % 60;
    return new TimeDifference(days, hours, minutes);
  }
}
